<jw-modal id='defectImageModal'>
  <div class="row">
    @for (doc of this.documents; track doc) {
      <div class="col-6">
        @if (doc.data !== undefined) {
          <img src='data:{{doc.filetype}};base64,{{doc.data}}'/>
        }
        <hr>
          {{doc.originalFilename}}
        </div>
      }
    </div>
    <div class="row">
      <div class="col">
        <button class='btn btn-warning' (click)='this.close()'>Close</button>
      </div>
    </div>
  </jw-modal>
